export default __webpack_public_path__ + "static/media/white_dress.2f00f69a.jpg";